import React, { useCallback } from "react";
import MedicineView from "./MedicineView";
import { medicinesData } from "../utils/constants";
import { useNavigate } from "react-router-dom";

function Game() {
  const navigate = useNavigate();
  const [activeMedicineIndex, setActiveMedicineIndex] = React.useState(0);
  const onMedicineQuestionsEnd = useCallback(() => {
    if (activeMedicineIndex < medicinesData.length - 1) {
      setActiveMedicineIndex(activeMedicineIndex + 1);
    } else {
      navigate("/rights");
    }
  }, [activeMedicineIndex]);
  return (
    <section className="game-container">
      <MedicineView
        medicine={medicinesData[activeMedicineIndex]}
        onMedicineQuestionsEnd={onMedicineQuestionsEnd}
      />
    </section>
  );
}

export default Game;
